
  import {Component, Vue, Prop} from "vue-property-decorator";
  import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
  import AppThCell from "@/shared/AppTable/components/AppThCell.vue";
  import {IApp} from "@/interfaces/app.interface";

  @Component({
    components: {
      AppThCell,
    }
  })
  export default class SimpleAppTable extends Vue {
    @Prop() dataProps: IAppTable.ITableProp[];
    @Prop() sortingData: IAppTable.ISortingData;
    @Prop() tableList: any[];
    @Prop() customComponents!: Record<string, Vue.Component>;
    @Prop({ default: 'Информация пока отсутствует.' }) emptyText!: string;
    @Prop() loading!: { process: boolean; text?: string; };

    $refs: any;
    propType = IApp.SortingPropType;

    async cellClick(cell: IAppTable.ITableProp, cellIndex: number, row: any, rowIndex: number) {
      if (cell.actionClick) {
        await cell.actionClick(row, rowIndex, cell, cellIndex);
      }
    }

    rowClick(row: any, rowIndex: number) {
      this.$emit('rowClick', { row, rowIndex });
    }

    setSorting(cell: IAppTable.ITableProp) {
      this.$emit('setSorting', cell);
    }

    emitAction(data: { actionName: string; payload: any }) {
      this.$emit(data.actionName, data.payload);
    }

  }
